import { AxiosResponse } from 'axios'
import apiInstance from '../../../../backend-api.setup'
import { ApiPathConfig } from '../../../../../config/ApiPathConfig'

const GetAudienceFile = (id: string): Promise<AxiosResponse<Blob>> => {
  return apiInstance.get(ApiPathConfig.AUDIENCE_FILE(id))
}

export default GetAudienceFile
